module.exports = require('./helpers/bundle-url').getBundleURL('9pgM9') + "open-new-window.91e0c18c.svg" + "?" + Date.now();